import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  size?: number | string;
}

const Backward: React.FunctionComponent<Props> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      fill='none'>
      <path
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        d='m15 18-6-6 6-6'
      />
    </svg>
  );
};

export default Backward;
